<header>
  <nav class="navbar navbar-expand-md fixed-top" role="navigation" aria-label="Navigation principale">
    <div class="container-fluid">
      <a class="navbar-brand" href="/" aria-label="Lusk - Retour à l'accueil">
        <img
          style="height: 40px"
          src="assets/imgs/favicon.png"
          alt=""
          aria-hidden="true"
          placement="bottom"
          ngbTooltip="Retour à la recherche Lusk"
          tooltipClass="lusk-tooltip"
        />
        <span class="visually-hidden">Lusk</span>
      </a>
      @if (installAvailable()) {
        <button
          class="btn btn-sm border-0 ms-auto"
          (click)="installApp()"
          aria-label="Installer l'application Lusk"
          placement="bottom"
          ngbTooltip="Installer l'application"
          tooltipClass="lusk-tooltip"
        >
          <i class="bi bi-download"></i>
        </button>
      }
      <button
        class="btn btn-sm border-0"
        [class.ms-auto]="!installAvailable()"
        (click)="theme.toggle()"
        [attr.aria-label]="theme.theme() === 'dark' ? 'Activer le thème clair' : 'Activer le thème sombre'"
        placement="bottom"
        ngbTooltip="{{ theme.theme() === 'dark' ? 'Thème clair' : 'Thème sombre' }}"
        tooltipClass="lusk-tooltip"
      >
        <i class="bi" [ngClass]="theme.theme() === 'dark' ? 'bi-sun-fill' : 'bi-moon-fill'"></i>
      </button>
    </div>
  </nav>
</header>
<main class="flex-shrink-0 mb-3">
  <div class="container" style="padding-top: 60px">
    @if (!online()) {
      <div class="alert alert-warning d-flex align-items-center gap-2 py-2 mt-2" role="status" aria-live="polite">
        <i class="bi bi-wifi-off" aria-hidden="true"></i>
        <span>Hors ligne : seuls les résultats en cache sont disponibles.</span>
      </div>
    }
    <router-outlet />
  </div>
</main>
<footer class="container" role="contentinfo">
  <app-liquid-container>
    <p class="text-center">
      Lusk.bzh — métamoteur breton & <span class="text-warning">respectueux de la vie privée</span>
    </p>
    <nav aria-label="Navigation pied de page">
      <ul class="list-inline text-center">
        <li class="list-inline-item"><a class="nav-link" routerLink="about">À propos</a></li>
        <li class="list-inline-item"><span class="vr" aria-hidden="true"></span></li>
        <li class="list-inline-item">
          <a class="nav-link" href="mailto:contact@lusk.bzh">Contact</a>
        </li>
      </ul>
    </nav>
  </app-liquid-container>
</footer>
